<template>
  <button @click="jumpRemoveOptionId({ jump, index })" v-show="show" class="kp-btn-action-sm kp-btn__danger"><i class="fa fa-minus"></i></button>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: [
    'jump',
    'index',
    'show',
  ],
  methods: mapActions([
    'jumpRemoveOptionId',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** RemoveOption.vue?6c5c75cb
 **/